import { ActionButton, type ActionButtonProps } from "@hamlak/ui";
import { t } from "@/i18n/ko";

type Props = Omit<ActionButtonProps, "children" | "variant">;

/** 시안 44:861: 흰 배경 · #1f1f1f · t5 bold · G 20 — Google 브랜드 규칙이라 토큰 대신 고정값. */
const GOOGLE_STYLE = { background: "#fff", color: "#1f1f1f", fontSize: "var(--seed-font-t5-size)", lineHeight: "var(--seed-font-t5-line)" } as const;

/** Google 로그인 버튼(brandSolid 1개 규칙 밖, neutralSolid 크기 large). 문구는 i18n. */
export function GoogleButton({ style, ...props }: Props) {
  return (
    <ActionButton variant="neutralSolid" size="large" block style={{ ...GOOGLE_STYLE, ...style }} {...props}>
      <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
        <GoogleG />
        {t("login.google")}
      </span>
    </ActionButton>
  );
}

function GoogleG() {
  return (
    <svg width="20" height="20" viewBox="0 0 48 48" aria-hidden>
      <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.5l6.7-6.7C35.7 2.6 30.2 0 24 0 14.6 0 6.5 5.4 2.5 13.3l7.8 6.1C12.2 13.6 17.6 9.5 24 9.5z" />
      <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.5 5.8c4.4-4 7.1-10 7.1-17.5z" />
      <path fill="#FBBC05" d="M10.3 28.6c-.5-1.5-.8-3-.8-4.6s.3-3.1.8-4.6l-7.8-6.1C.9 16.5 0 20.1 0 24s.9 7.5 2.5 10.7l7.8-6.1z" />
      <path fill="#34A853" d="M24 48c6.2 0 11.5-2 15.4-5.6l-7.5-5.8c-2.1 1.4-4.8 2.2-7.9 2.2-6.4 0-11.8-4.1-13.7-9.9l-7.8 6.1C6.5 42.6 14.6 48 24 48z" />
    </svg>
  );
}
